import { BaseModel } from '~/models/baseModel';
import { StateModel } from '~/models/constants/stateModel';

export class CountryModel extends BaseModel {
    public name:string;
    public longName:string;
    public states:StateModel[];
}